import React from 'react';
import ResultToolbarPrimary from './ResultToolbarPrimary';
import ResultToolbarSecondary from './ResultToolbarSecondary';

/**
 * FR-4.3: `id="main-content"` was moved OFF this toolbar onto the primary results region
 * (`.results-content`, see ResultsContentSection.jsx) so Results matches every other page where
 * `main-content` is the content landmark. The toolbar keeps its accessible name (`aria-label`).
 * This view is Results-only (Heatmap renders ResultToolbarHeatmapView and owns its own
 * `#main-content` on `.results-wrapper`), so exactly one `#main-content` remains on every page that
 * renders a toolbar.
 */
export function ResultToolbarDefaultView(props) {
  return (
    <section
      // RX-23573: named "Results actions toolbar". This is a `region` landmark (not an ARIA
      // `toolbar` widget); the name describes the sorting/limit/export/zoom actions it groups.
      aria-label="Results actions toolbar"
      className="result-toolbar u-els-padding-top u-els-padding-bottom u-els-padding-top-1o2@tablet u-els-padding-bottom-1o2@tablet u-els-padding-top-1o4@mobile u-els-padding-bottom-1o4@mobile">
      <ResultToolbarPrimary {...props} />
      <ResultToolbarSecondary {...props} />
    </section>
  );
}

export default ResultToolbarDefaultView;
